export enum BusinessType {
    Other = 0,
    DiamondWholesaler = 1,
    JewelryManufacturer = 2,
    JewelryRetail = 3,
    JewelryWholesaler = 4,
    DiamondRetailer = 5
}



// WEBPACK FOOTER //
// ./src/app/enums/business-type.ts